import Teams from './Teams'

const TeamAdminSettingsPage = () => {
  return <Teams />
}

export default TeamAdminSettingsPage
